module.exports = __webpack_public_path__ + "static/11-62f42be9e5038657408ee3e9487a68d0.jpg";